import { useContext, useEffect, useRef, useState } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { ApiContext } from "../context/ApiContext";

// import { Box } from "@mui/material";
const VideoPlayer = (props) => {
  const videoNode = useRef(null);
  const [player, setPlayer] = useState(null);
  const {audioCtxRef,sourceRef} = useContext(ApiContext)
  useEffect(() => {
    // console.log(props,"here prop");
audioCtxRef.current = null;
sourceRef.current = null;
    if (videoNode.current) {
      const _player = videojs(videoNode.current, props);
      setPlayer(_player);
      return () => {
        if (player !== null) {
          player.dispose();
        }
      };
    }
  }, []);


  return (
    // <Box
    //   sx={{
    //     minHeight: '100vh',
    //     width: '100vw',
    //     backgroundColor:'black',
    //     flex: 1, // Take all available space
    //     overflowY: "auto", // Enable vertical scrolling
    //     paddingBottom: "90px", // Space for Bottom Navigation
    //     paddingTop{
    //       xs:'50%',lg:'0%'
    //     }

    //   }}
    // >
    <div className="Video-player">
      <div data-vjs-player>
        <video ref={videoNode} className="video-js"></video>
      </div>
    </div>

    // </Box>
  );
};
export default VideoPlayer;